export default "__VITE_ASSET__7qm0NMa1__"